







import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import {executeQuery} from "@/data/repos/query"
import {getLocationCaption} from "@/data/sources/appraisal"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Gauge(),
    widget: "ComplianceSingleElementScore",
    title: "Single Element Score",
    w: 2, // override base template
    h: 1, // same here
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
      complianceElementId: {...WParamTpl.complianceElementId(), _order: 2},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
    ...ChartDataTemplate(),
    caption: 'Score',
    upperLimit: "100",
    lowerLimit: "0",
    lowerLimitDisplay: "Compliancy",
    upperLimitDisplay: "",
    showValue: "1",
    valueBelowPivot: "0",
    legendCaptionFontSize: "10",
  })
}

function chartDSTemplate() { // required if FC data not in {data: {}} format
  return {
    categories: [],
    chart: {},
    dataset: [],
  }
}

async function getTitle(params: any) {
  if (params.complianceElementId.value.title) {
    return "Location: " + await getLocationCaption(params.locationId) + ", Element: " + params.complianceElementId.value.title
  } else { // old parameter handling (can be removed after GA)
    const r = await executeQuery("idr", "autocompleteComplianceElementId", {id: params.complianceElementId.value})
    const elTitle = r ? r[0].title : "???"
    return "Location: " + await getLocationCaption(params.locationId) + ", Element: " + elTitle
  }
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = await getTitle(config.params)
  }
}

export default defineComponent({
  props: {config: {type: Object, required: true}},
  components: {FusionChartWidget},
  setup(props, context) {
    context.emit("config-update", config())

    async function dataplotClickCallback(label: string, val: any) {
      const locationId = parseInt(props.config.params.locationId.value)
      const elementId = props.config.params.complianceElementId.value.title ? props.config.params.complianceElementId.value.value : props.config.params.complianceElementId.value
      bus.$emit("chartPopup", {
        title: "Single element score - " + await getTitle(props.config.params),
        component: drillDown,
        componentArgs: {
          locationId, elementId
        },
      })
    }

    return {dataFetcher, getChartDataConfig, dataplotClickCallback, chartDSTemplate, configChangeCallback}
  },
})

async function dataFetcher(params: any): Promise<{ Label: string, Value: number }[] | null> {
  return await executeQuery("idr", "compliance.singleElementScore", {
    locationId: parseInt(params.locationId.value),
    elementId: params.complianceElementId.value.title ? params.complianceElementId.value.value : params.complianceElementId.value
  }, convert)
}

function convert(data: { Label: string, Value: number }[]): any {
  const valueMap = new Map<string, number>()
  for (const item of data) {
    valueMap.set(item.Label, item.Value)
  }
  const compliantValue = valueMap.get("Compliant") || 0
  // const nonCompliantValue = valueMap.get('NonCompliant') || 0
  const totalValue = valueMap.get("Total") || 0
  // const naValue = (valueMap.get('Total') || 0) - (compliantValue + nonCompliantValue)
  const compliantPercentage = (100.0 * compliantValue / totalValue).toFixed(0)
  return {
    colorRange: {
      color: [
        {
          minValue: "0",
          maxValue: compliantPercentage,
          code: "#6baa01",
        },
        {
          minValue: compliantPercentage,
          maxValue: "100",
          code: "#db143c",
        },
      ],
    },
    dials: {
      dial: [
        {
          value: compliantPercentage,
        },
      ],
    },
  }
}

const drillDown = () => ({
  component: import("@/components/drilldowns/ComplianceSingleElementScoreDrillDown.vue"),
})
